import React from 'react';
import PropTypes from 'prop-types';

import Picture from '@Theme/hijunior/components/Picture/Picture';
import Icon from '@Theme/hijunior/components/Icon/Icon';

import * as styles from './ArticleTile.module.scss';

const propTypes = {
  href: PropTypes.string,
  picture: PropTypes.shape({
    xs: PropTypes.exact({
      src: PropTypes.string,
      width: PropTypes.number,
      height: PropTypes.number
    }),
    alt: PropTypes.string
  }),
  category: PropTypes.string,
  heading: PropTypes.string,
  description: PropTypes.string,
  date: PropTypes.string,
  readTime: PropTypes.string
};

const ArticleTile = ({
  href,
  picture,
  category,
  heading,
  description,
  date,
  readTime
}) => {
  if (!href && !picture && !category && !heading && !description && !date && !readTime) {
    return false;
  }

  return <div className={styles.root}>
    <a href={href} className={styles.rootCard}>
      {(picture?.xs.src) && <Picture {...picture} pictureClassname={styles.rootCardPicture} imgClassname={styles.rootCardImage}/>}
      {!picture?.xs.src && <div
        className={`${styles.rootCardPicture} ${styles.rootCardPicturePlaceholder}`}>
        <Icon name='placeholder' size={{
          width: 48,
          height: 48
        }}/>
      </div>}
      <div>
        {category && <span className={styles.rootCardCategory}>{category}</span>}
        {heading && <div className={styles.rootCardHeading}>{heading}</div>}
        {description && <div className={styles.rootCardDescription}>{description}</div>}
        {date && <div className={styles.rootCardDetails}>
          <span className={styles.rootCardDate}>{date}</span>
          {readTime && <div className={styles.rootCardReadTimeWrapper}>
            <Icon classname={styles.rootCardReadTimeIcon} name='readingTime' size={{
              width: 15,
              height: 15
            }}/>
            <span className={styles.rootCardReadTime}>{readTime}</span>
          </div>}
        </div>}
      </div>
    </a>
  </div>;
};

ArticleTile.propTypes = propTypes;

export default ArticleTile;
